import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { IGetServiceProps } from "@api/types/globalService.types";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useGetAllAlertTemplateServices = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const created_between = urlQueries["created_between"] || "";

  const allAlertTemplateService = useQuery({
    queryKey: [...CACHE_KEYS.ALERT_TEMPLATES, page, per_page, created_between],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.ALERT_TEMPLATES,
        searchParams: {
          page: page,
          include: "partner,alert,partner.policies.product,product",
          "filter[created_between]": created_between,
          per_page: per_page,
        },
      }),
    enabled: enableQuery,
  });
  return {
    services: { allAlertTemplateService },
  };
};
